import { Model as ORMModel, attr, many, fk } from 'redux-orm'
import { Types } from '@fedsim/actions'

import { ProductionMachine } from 'stateMachines/production'
interface ProductionStatsInterface {
  attendance: number
  attendanceIncome: number
  merchIncome: number
  viewers: number
  wrestlersCost: number
  segmentsCost: number
  outgoings: number
  income: number
  payout: number
  singlePayout: number
}

function generateStats(production): ProductionStatsInterface {
  const newProduction = new ProductionMachine({ ...production, complete: true }).calculate().applyPayouts().recordFuzz().getState()

  return newProduction;
}

export class Production extends ORMModel {
  static get fields() {
    return {
      id: attr(),
      name: attr({ getDefault: () => '' }),
      desc: attr({ getDefault: () => '' }),
      image: attr({ getDefault: () => '' }),
      date: attr({ getDefault: () => new Date() }),
      venueId: attr({ getDefault: () => "DEFAULT" }),

      segmentIds: many({
        to: 'Segment',
        as: 'segments',
        relatedName: 'ProductionSegments'
      }),
      brandIds: many({
        to: 'Brand',
        as: 'brands',
        relatedName: 'ProductionBrands'
      }),

      showId: fk({
        to: 'Show',
        as: 'show',
        relatedName: 'ProductionShow'
      }),

      color: attr({ getDefault: () => '#000' }),
      backgroundColor: attr({ getDefault: () => '#fff' }),

      // cost
      wrestlersCost: attr({ getDefault: () => 0 }),
      segmentsCost: attr({ getDefault: () => 0 }),
      // income
      merchIncome: attr({ getDefault: () => 0 }),
      attendanceIncome: attr({ getDefault: () => 0 }),
      //
      attendance: attr({ getDefault: () => 0 }),
      viewers: attr({ getDefault: () => 0 }),
      //completions
      step: attr({ getDefault: () => 0 }),
      complete: attr({ getDefault: () => false }),
    }
  }

  static reducer(action, Production, session) {
    let item
    switch (action.type) {
      case Types.RESET:
      case Types.RESET_PRODUCTIONS:
        session.Production.all()
          .toModelArray()
          .forEach(item => item.delete())
        break
      case Types.ADD_PRODUCTION:
        item = action.payload.id
          ? session.Production.withId(action.payload.id)
          : false
        if (!item) {
          session.Production.upsert(action.payload)
        }
        break

      case Types.UPDATE_PRODUCTION:
        item = session.Production.withId(action.payload.id)
        if (item) {
          item.update(action.payload)
        }
        break
      // case Types.REMOVE_PRODUCTION:
      case Types.DELETE_PRODUCTION: {
        session.Production.withId(action.payload.id).delete()
        break
      }
      case Types.PRODUCTION_COMPLETE: {
        let newProduction = generateStats(action.payload)

        session.Production.withId(action.payload.id).update(newProduction)
      }
        break
      case Types.GENERATE_PRODUCTIONS:
        action?.payload?.forEach(newItem => {
          session.Production.upsert(newItem)
        })
        break
      case Types.DELETE_SEGMENT:
        session.Production.all()
          .toModelArray()
          .forEach(item => {
            item = session.Production.withId(item.id)
            item.segmentIds = item.segmentIds.filter(
              segmentId => segmentId !== action.payload.id
            )

            item.update(item)
          })
        break
    }
  }
}

export default Production
